const getSpecialManualRecordScopes = [
  'SPECIAL_MANUAL_RECORDS_REMOVED',
];
const chains = [];
chains.push({ _operation: 'createSpecialManualRecord', api: '/special-manual-record', defaultData: null, httpVerb: 'post' });
chains.push({ _operation: 'getSpecialManualRecords', api: '/special-manual-records', defaultData: [], httpVerb: 'get', scopes: getSpecialManualRecordScopes });
chains.push({ _operation: 'removeSpecialManualRecordById', api: '/special-manual-record/:objectId/remove', defaultData: null, httpVerb: 'put' });
chains.push({ _operation: 'updateSpecialManualRecordById', api: '/special-manual-record/:objectId', defaultData: null, httpVerb: 'patch' });
export default chains;
